import className from 'classnames/bind';
import styles from './FeaturedPosts.module.scss';
import { Button, FeaturedImage, Grid, Heading, PostsHero } from '@/components';
import { useFirstCategory } from '@/hooks/useFirstCategory';
import Link from 'next/link';

let cx = className.bind(styles);

export function FeaturedPosts({ posts }) {
	return (
		posts.nodes?.length > 0 && (
			<PostsHero className={cx(['featured-posts-hero', 'bg-neutral-lightest'])}>
        <Heading level="h2" className="sr-only">Featured Post</Heading>
				{posts.nodes.map((post) => (
					<Post key={post.id} post={post} />
				))}
			</PostsHero>
		)
	);
}

function Post({ post }) {
	const category = useFirstCategory(post.categories?.nodes);
	return (
		<article className={cx('ns_featured-article', 'featured-article')}>
			<Grid colCount={12} alignItems="center" className={cx(['featured-article-grid'])}>
				<div className={cx('ns_blog-header-text-container', 'blog-header-text-container', !post.featuredImage && 'full')}>
					{category && <p className={cx(['is-style-heading-eyebrow'])}>{category.name}</p>}
					<Heading level="h3" className={cx('featured-post-title', 'is-style-heading-headline', 'is-font-size-sm')}>
						{post.title}
					</Heading>
					<Button href={post.uri}>Read More</Button>
				</div>
				{post.featuredImage && (
					<Link className={cx('ns_featured-image-container', 'featured-image-container')} href={post.uri}>
						<FeaturedImage image={post.featuredImage} className={cx('image')} priority={true} sizes='(max-width: 500px) 100vw, (max-width: 820px) 460px, (max-width: 1600px) 41vw, 580px' />
					</Link>
				)}
			</Grid>
		</article>
	);
}
